import React, { useState } from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import { get, has, invoke } from 'lodash';

const buttonStyle = css`
  background: 0;
  border: none;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
`;

const ExpandOrderButton = (props) => {
  const [expanded, setExpanded] = useState(get(props, 'expanded', false));

  const _expanded = has(props, 'expanded') ? get(props, 'expanded') : expanded;

  const handleClick = (event) => {
    const newVal = !_expanded;
    setExpanded(newVal);
    invoke(props, 'onChange', newVal);
    if (expanded === false && window?.['eddlLoadComplete']) {
      window['AB'].DATALAYER.snsExpandButtonClick(event.target);
    }
  };

  return (
    <button className={buttonStyle} onClick={handleClick} aria-label="expand">
      {_expanded ? (
        <svg
          pointerEvents="none"
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.292893 7.70711C0.683417 8.09763 1.31658 8.09763 1.70711 7.70711L7 2.41421L12.2929 7.70711C12.6834 8.09763 13.3166 8.09763 13.7071 7.70711C14.0976 7.31658 14.0976 6.68342 13.7071 6.29289L7.70711 0.292893C7.31658 -0.0976315 6.68342 -0.0976315 6.29289 0.292893L0.292893 6.29289C-0.0976311 6.68342 -0.0976311 7.31658 0.292893 7.70711Z"
            fill="#7B1A27"
          />
        </svg>
      ) : (
        <svg
          pointerEvents="none"
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.7071 0.292893C13.3166 -0.0976311 12.6834 -0.0976311 12.2929 0.292893L7 5.58579L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976315 0.683417 -0.0976315 1.31658 0.292893 1.70711L6.29289 7.70711C6.68342 8.09763 7.31658 8.09763 7.70711 7.70711L13.7071 1.70711C14.0976 1.31658 14.0976 0.683417 13.7071 0.292893Z"
            fill="#7B1A27"
          />
        </svg>
      )}
    </button>
  );
};

ExpandOrderButton.propTypes = {
  expanded: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ExpandOrderButton;
